import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { useAuth } from "./AuthProvider";

function SessionCheckScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-paper">
      <Loader2 className="h-6 w-6 animate-spin text-ink-400" aria-hidden="true" />
    </div>
  );
}

/** Wrap any route that requires a signed-in user. */
export function RequireAuth({ children }) {
  const { isCheckingSession, isSignedIn } = useAuth();
  const location = useLocation();

  if (isCheckingSession) return <SessionCheckScreen />;
  if (!isSignedIn) return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  return children;
}

/** Wrap any route that requires an admin. Assumes it's already inside RequireAuth. */
export function RequireAdmin({ children }) {
  const { isCheckingSession, isSignedIn, isAdmin } = useAuth();

  if (isCheckingSession) return <SessionCheckScreen />;
  if (!isSignedIn) return <Navigate to="/login" replace />;
  if (!isAdmin) return <Navigate to="/" replace />;
  return children;
}

/** Wrap the login route: an already-signed-in user shouldn't see it. */
export function RedirectIfSignedIn({ children }) {
  const { isCheckingSession, isSignedIn } = useAuth();

  if (isCheckingSession) return <SessionCheckScreen />;
  if (isSignedIn) return <Navigate to="/" replace />;
  return children;
}
